// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","container_loyalty":"container_loyalty-2Lj7G","container":"container-2vEtl","toggle":"toggle-3tmMK","loyaltySwitchOpen":"loyaltySwitchOpen-1G5p-"};